import './Prostep.css'

import { AuthProvider } from '../auth/authlib';
import React, { useState, useEffect, useRef } from 'react'
import PartNrTable from '../components/PartNrTable';
import AlternateTable from '../components/AlternateTable';
import SplitPane from '../components/SplitPane';
import AssignmentActionBar from '../components/AssignmentActionBar';
import MaterialTabs from '../components/MaterialTabs';
import { AssignmentProvider, useAssignment } from '../hooks/useAssignment';
import { useConnectors } from '../hooks/useConnectors';
import { useReadySignal } from '../hooks/useReadySignal';
import { Toast } from '../components/Toast';

export default function Prostep(): JSX.Element {
  return (
    <AssignmentProvider>
      <ProstepContent />
    </AssignmentProvider>
  );
}

function ProstepContent(): JSX.Element {
  const [iFrameUrl, setIframeUrl] = useState('');
  const [currentTab, setCurrentTab] = useState('iframe');
  const leftPaneRef = useRef<HTMLDivElement>(null);

  const assignment = useAssignment();
  const leftConnector = useConnectors();
  useReadySignal();

  useEffect(() => {
    const authProvider = new AuthProvider();
    authProvider.requireLogin();
    if (authProvider.isauthenticated()) {
      setIframeUrl(authProvider.getAuthenticatedUrl());
    }
    // If not authenticated, requireLogin() is already redirecting to SSO —
    // leave iFrameUrl empty so nothing is rendered until the redirect completes.
  }, []);

  if (!iFrameUrl) return <></>;

  return (
    <>
      <SplitPane
        left={
          <div ref={leftPaneRef} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ width: '100%', maxHeight: '35vh', minHeight: '5em' }}>
              <PartNrTable partnrs={assignment.viewPartNrs} />
            </div>
            <div style={{ width: '100%', maxHeight: '35vh', overflowY: 'auto' }}>
              <AlternateTable onDeselect={() => setCurrentTab('iframe')} scopeRef={leftPaneRef} />
            </div>
            <AssignmentActionBar leftConnector={leftConnector} activeTab={currentTab} />
          </div>
        }
        right={
          <MaterialTabs activeTab={currentTab} onTabChange={setCurrentTab} iFrameUrl={iFrameUrl} />
        }
      />
      <Toast visible={leftConnector.toast.visible} message={leftConnector.toast.message} variant={leftConnector.toast.variant} onDismiss={leftConnector.toast.dismiss} />
    </>
  );
}
